import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierFilledHyperstarFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M11 1c1.399 0 2.624.174 3.691.49-.229.184-.458.358-.689.512L11.755 3.5l2.247 1.498a11.5 11.5 0 0 1 3 3l1.498 2.247 1.498-2.247q.226-.336.494-.669C20.844 8.501 21 9.75 21 11c0 2.418-.585 4.837-2.037 6.69l4.033 4.034-1.272 1.272-4.026-4.025C16.142 20.22 13.96 21 11 21 3.5 21 1 16 1 11S3.5 1 11 1"
                    fill="currentColor"
                />
                <path
                    d="M18.5 0A13.3 13.3 0 0 0 22 3.5 13.3 13.3 0 0 0 18.5 7 13.3 13.3 0 0 0 15 3.5 13.3 13.3 0 0 0 18.5 0"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
MagnifierFilledHyperstarFilledSize24Glyph.displayName = 'MagnifierFilledHyperstarFilledSize24Glyph';
